import React, { useEffect, useState } from "react";
import { Col, Container, Modal, ProgressBar, Row } from "react-bootstrap";
import classes from "./joinDoctor.module.css";
import humaaansStanding11 from "../../assets/imgsDoctors/humaaans-standing-11.png";
import humaaansstanding17 from "../../assets/imgsDoctors/humaaans-standing-17.png";
import Patients from "../../assets/imgsDoctors/Patients.png";
import doctorMobile from "../../assets/imgsDoctors/doctor mobile.png";
import appStore from "../../assets/imgsDoctors/app store.png";
import googlePlay from "../../assets/imgsDoctors/google play.png";
import { Element } from "react-scroll";
import { useTranslation } from "react-i18next";
import Cookies from "js-cookie";

const JoinDoctor = () => {
  const [t, i18n] = useTranslation();
  const [animation, setAnimation] = useState(window.scrollY);
  const breakpoint = 66;

  const currentLangsCode = Cookies.get("i18next") || "en";

  useEffect(() => {
    window.addEventListener("scroll", () => setAnimation(window.scrollY));
  }, [animation]);
  const [show, setShow] = useState(false);
  
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (
    // <Element name="JoinDoctor">
    //   <div className={`${classes.features}`} style={{ direction: "ltr" }}>
    //     <Container fluid>
    //       <h3>{t("Join As a Doctor")}</h3>
    //       <Row
    //         style={{
    //           display: "flex",
    //           //   justifyContent: "center",
    //           alignItems: "flex-end",
    //         }}
    //       >
    //         <Col lg={3}>
    //           <div
    //             className={`${classes.featuresContent} ${classes.animations1}`}
    //           >
    //             <img
    //               src={humaaansStanding11}
    //               alt=""
    //               className={classes.Patient1}
    //             />
    //             <img
    //               src={humaaansstanding17}
    //               alt=""
    //               className={classes.Patient3}
    //             />
    //           </div>
    //         </Col>
    //         <Col lg={5} className={`col-md-12 ${classes.animations2Margin}`}>
    //           <div
    //             className={`${classes.featuresContent} ${classes.animations2}`}
    //           >
    //             <div className={classes.useContainer}>
    //               <p>{t("joinDoctor paragraph")}</p>
    //               <div className={classes.socialMedia}>
    //                 <img src={appStore} alt="" />
    //                 <img src={googlePlay} alt="" />
    //               </div>
    //             </div>
    //           </div>
    //         </Col>
    //         <Col lg={3} className="col-md-12">
    //           <div
    //             className={`${classes.featuresContent} ${classes.animations3}`}
    //           >
    //             <img src={doctorMobile} alt="" className={classes.Patients} />
    //           </div>
    //         </Col>
    //       </Row>
    //     </Container>
    //   </div>
    // </Element>
    <div className={`${classes.features}`} style={{ direction: "ltr" }}>
      <Container fluid>
        <h3>{t("Join As a Doctor")}</h3>
        <div>
          <div
            className={`${classes.featuresContent} ${
              animation > breakpoint && classes.animations2
            }`}
          >
            <img src={humaaansStanding11} alt="" className={classes.Patient1} />
            <img src={humaaansstanding17} alt="" className={classes.Patient3} />
            <div className={classes.useContainer}>
              <p>{t("joinDoctor paragraph")}</p>
              <div className={classes.socialMedia}>
              
                <img src={appStore} onClick={handleShow} className={classes.appGooglePlay}  alt="" />
                <Modal  onHide={handleClose} show={show} aria-labelledby="contained-modal-title-vcenter" centered>
                <div className={classes.modalComing}>
                <h1>Coming soon..</h1>
                <ProgressBar now={50} />
                </div>
                </Modal>
                <a href="https://play.google.com/store/apps/details?id=com.arqaam.i_doctors_for_doctors&hl=en&gl=US" className={classes.appGooglePlay}>
                <img src={googlePlay} alt="" />
                </a>
              </div>
            </div>
            <img src={doctorMobile} alt="" className={classes.Patients} />
          </div>
        </div>
      </Container>
    </div>
  );
};

export default JoinDoctor;
